import React from 'react';
import { clsx } from 'clsx';
import { motion } from 'framer-motion';

const MetricCard = ({ title, value, unit, status = 'default', subtext, icon: Icon, delay = 0 }) => {
  const statusColors = {
    default: 'text-text',
    good: 'text-primary',
    warning: 'text-warning',
    danger: 'text-danger',
  };

  const bgColors = {
    default: 'border-white/5',
    good: 'border-primary/20 bg-primary/5',
    warning: 'border-warning/20 bg-warning/5',
    danger: 'border-danger/20 bg-danger/5',
  };

  return (
    <motion.div 
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay }}
      className={clsx(
        "relative overflow-hidden rounded-xl border p-4 transition-colors",
        bgColors[status] || bgColors.default
      )}
    >
      <div className="flex justify-between items-start mb-2">
        <h3 className="text-xs font-semibold uppercase tracking-wider text-muted">{title}</h3>
        {Icon && <Icon className={clsx("w-4 h-4", statusColors[status])} />}
      </div>
      
      <div className="flex items-baseline gap-1">
        <span className={clsx("text-2xl font-bold tabular-nums", statusColors[status])}>
          {value}
        </span>
        {unit && <span className="text-sm font-medium text-muted">{unit}</span>}
      </div>

      {subtext && (
        <p className="mt-2 text-xs text-muted/80">{subtext}</p>
      )}
    </motion.div>
  );
};

export default MetricCard;